export default __webpack_public_path__ + "static/media/buymore.6230bcc8.svg";